import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthResponse } from './types';
import { apiUrl, cognitoRedirectUri } from '../../config';

export const AUTH_API_REDUCER_KEY = 'authApi';
export const authApi = createApi({
    reducerPath: AUTH_API_REDUCER_KEY,
    baseQuery: fetchBaseQuery({
        baseUrl: `${apiUrl}`,
    }),
    endpoints: (builder) => ({
        getAccessToken: builder.query<AuthResponse, string>({
            query: (code) => {
                return {
                    // The exchange must present the same redirect_uri the
                    // authorize request used; it varies with the deployment's
                    // base path, so the server cannot derive it.
                    url: `oauth2/token/${code}?redirect_uri=${encodeURIComponent(cognitoRedirectUri)}`,
                    method: 'GET',
                };
            },
        }),
    }),
});
